import Phone from '@/assets/phone.svg?react';
import Button from '@/components/ui/Button';

import { useLingui } from '@lingui/react';

const ErrorTemplate = ({
  code,
  message,
}: {
  code: string | number;
  message?: string;
}) => {
  const { i18n } = useLingui();
  return (
    <section>
      <div className="mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
        <div className="mx-auto flex max-w-screen-sm flex-col items-center gap-y-6 text-center">
          <h1 className=" text-[135px] font-extrabold leading-[124px] tracking-[-14px] text-oxford-blue-100 lg:text-[175px] lg:leading-[174px]">
            {code}
          </h1>
          <p className="text-[25px] font-bold leading-7 text-oxford-blue-100 md:text-[26px] md:leading-[34px]">
            Upss, coś poszło nie tak
          </p>
          {message ? (
            <p className="body font-normal text-dark-gray-500">{message}</p>
          ) : (
            <div className="space-y-1">
              <p className="body font-normal text-dark-gray-500">
                Houston, mamy problem! Nasz serwer zniknął na chwilę z horyzontu
                internetowego.
              </p>
              <p className="body font-normal text-dark-gray-500">
                Prosimy o wyrozumiałość, wracamy za chwilę.
              </p>
            </div>
          )}
        </div>
        <div className="mx-auto mt-12 w-fit">
          <a href="https://helpfind.pl/kontakt" target="blank" rel="nofollow">
            <Button>
              <Phone width={18} />
              {i18n.t('Skontaktuj się')}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ErrorTemplate;
